import { Component, OnInit } from '@angular/core';
import { DomainBrandService } from '@services/domain-brand.service';
@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit {
  constructor(public brand: DomainBrandService) {}

  ngOnInit(): void {}
}
